module.exports = __webpack_public_path__ + "img/dasa.b3cc353f.jpg";